import { MutationTree } from 'vuex';
import { AdpFileControlState } from '@/store/modules/adp-file-control/index';
import {
  SET_ADP_CUSTOMERS, SET_ADP_FILES,
  SET_ADP_FILES_ERRORS,
  SET_ADP_FILES_LOADING,
} from '@/types/adp-file-control.types';
import { Grid } from '@/models/Grid.model';
import { AdpFileControlModel } from '@/models/backoffice/AdpFileControlModel';

export const mutations: MutationTree<AdpFileControlState> = {

  [SET_ADP_FILES_ERRORS]: (state, adpFilesErrors: string[]) => {
    state.adpFilesErrors = adpFilesErrors;
  },

  [SET_ADP_FILES_LOADING]: (state, adpFilesLoading: boolean) => {
    state.adpFilesLoading = adpFilesLoading;
  },

  [SET_ADP_FILES]: (state, adpFileList: Grid<AdpFileControlModel>) => {
    state.adpFileList = adpFileList;
  },

  [SET_ADP_CUSTOMERS]: (state, adpCustomers: Grid) => {
    state.adpCustomers = adpCustomers;
  },

};